import { render, staticRenderFns } from "./ContractServiceConsignmentProcedure.vue?vue&type=template&id=43d906c2&"
import script from "./ContractServiceConsignmentProcedure.vue?vue&type=script&lang=js&"
export * from "./ContractServiceConsignmentProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports